var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewFeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.766,
    height: 32.725,
    viewBox: "0 0 25.766 32.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-product_12288290",
    transform: "translate(-65.298 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(65.659 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M247.718,19a.4.4,0,0,1-.807,0V16.4a.4.4,0,1,1,.807,0Z",
    transform: "translate(-235.009 -16)",
    fill: "#eceff1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M315.422,48.592a.4.4,0,1,1-.571-.571l1.836-1.836a.4.4,0,0,1,.57.571Z",
    transform: "translate(-298.207 -44.017)",
    fill: "#eceff1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M158.673,48.023a.4.4,0,0,1-.571.571l-1.836-1.836a.4.4,0,1,1,.57-.571Z",
    transform: "translate(-150.433 -44.018)",
    fill: "#eceff1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M115.093,309.69a.578.578,0,0,1-.625.051l-6.626-3.447v6.762a.672.672,0,0,0,.341.594l4.7,2.742,4.7,2.739a.685.685,0,0,0,.346.1V307.57Z",
    transform: "translate(-105.421 -286.503)",
    fill: "#f2d1a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M255.8,307.57v11.658a.686.686,0,0,0,.347-.1l4.7-2.739,4.7-2.742a.672.672,0,0,0,.341-.594v-6.762l-6.626,3.447a.578.578,0,0,1-.625-.051l-2.836-2.12Z",
    transform: "translate(-243.292 -286.503)",
    fill: "#e3a76f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M82.006,247.432l2.836-2.119h0l-10.007-5.831-2.348,2.544a.566.566,0,0,0-.142.5.573.573,0,0,0,.308.418l2.1,1.093,6.626,3.447a.579.579,0,0,0,.626-.051Z",
    transform: "translate(-72.334 -224.245)",
    fill: "#e3a76f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M258.639,248.146a.578.578,0,0,0,.625.051l6.626-3.447,2.1-1.093a.572.572,0,0,0,.308-.418.566.566,0,0,0-.142-.5l-2.267-2.492-10.082,5.776-.005,0Z",
    transform: "translate(-243.294 -224.958)",
    fill: "#f2d1a5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M129.12,175.108l-6.251-3.73a7.645,7.645,0,0,0-7.463-.124l-6.38,3.8,10.007,5.832Z",
    transform: "translate(-106.523 -159.819)",
    fill: "#c48958",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M193.431,102.726l-.649-2.012a.534.534,0,0,0-1.017,0l-.649,2.012a.527.527,0,0,1-.509.37l-2.114,0a.534.534,0,0,0-.314.967l1.713,1.239a.527.527,0,0,1,.195.6l-.657,2.009a.534.534,0,0,0,.823.6l1.708-1.246a.527.527,0,0,1,.63,0L194.3,108.5a.534.534,0,0,0,.823-.6l-.657-2.009a.527.527,0,0,1,.195-.6l1.713-1.239a.534.534,0,0,0-.314-.967l-2.114,0A.527.527,0,0,1,193.431,102.726Z",
    transform: "translate(-114.415 -78.594)",
    fill: "#ffe177",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M365.037,106.1l1.142-.826a.356.356,0,0,0-.209-.644l-1.409,0a.351.351,0,0,1-.339-.247l-.433-1.341a.356.356,0,0,0-.678,0l-.433,1.341a.351.351,0,0,1-.339.247l-1.409,0a.356.356,0,0,0-.209.644l1.141.826a.351.351,0,0,1,.13.4l-.438,1.339a.356.356,0,0,0,.548.4l1.138-.83a.351.351,0,0,1,.42,0l1.138.83a.356.356,0,0,0,.548-.4l-.438-1.339A.351.351,0,0,1,365.037,106.1Z",
    transform: "translate(-275.262 -80.883)",
    fill: "#ffe177",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M71.375,106.5a.351.351,0,0,1,.13-.4l1.141-.826a.356.356,0,0,0-.209-.644l-1.409,0a.351.351,0,0,1-.339-.247l-.433-1.341a.356.356,0,0,0-.678,0l-.433,1.341a.351.351,0,0,1-.339.247l-1.409,0a.356.356,0,0,0-.209.644l1.142.826a.351.351,0,0,1,.13.4l-.438,1.339a.356.356,0,0,0,.548.4l1.139-.83a.351.351,0,0,1,.42,0l1.139.83a.356.356,0,0,0,.548-.4Z",
    transform: "translate(-1.741 -80.883)",
    fill: "#ffe177",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFeat);
export default __webpack_public_path__ + "static/media/new-feat.f724fe1eeedd97090a5604542533018a.svg";
export { ForwardRef as ReactComponent };